export default __webpack_public_path__ + "static/media/10.aafc284c.jpeg";